<ng-container *ngIf="doc.type === 'warehouse-transfer'">
  <div class="col">
    <p class="mb-2">
      <b>{{ 'document.document-view.warehouse-transfer.source' | translate }}:</b>
      <br />
      {{ doc.warehouse.name }}
    </p>

    <p class="mb-2">
      <b>{{ 'document.document-view.warehouse-transfer.destination' | translate }}:</b>
      <br />
      {{ doc.destinationWarehouse.name }}
    </p>
  </div>

  <div class="col col-sm-auto text-right">
    <p class="mb-2"></p>

    <p class="mb-2"></p>
  </div>
</ng-container>
